import { getFeatureFlags, getFeatureFlag } from '../../apiServices/featureFlagService';

export const moduleState = {
  flags: {},
  isInit: false,
};

export const getters = {
  flags: state => state.flags,
  getFlag: state => flagName => (state.flags[flagName] ?? false) === true,
  isInit: state => state.isInit,
  medicareConsentEnabled: state => state.flags.MedicareConsent === true,
  isDayCapByScheduleEnabled: state => !!state.flags?.EnableDayCapBySchedules,
  callCreditsEnabled: state => state.flags?.CallCredits === true,
  isBulkBucketFundingEnabled: state => state.flags?.EnableBulkBucketFunding === true,
  isChatbotEnabled: state => state.flags?.Chatbot === true,
  isSelfServiceReactivationEnabled: state => state.flags?.EnableSelfServiceReactivation === true,
};

export const actions = {
  async populateFlags({ commit }) {
    const flags = await getFeatureFlags([
      'CorporateChannelList',
      'FarmersBillingUpload',
      'TerritoryExpansion',
      'EliteAgentDisplay',
      'AutomatedCancelation',
      'StateFarmCombinedUpload',
      'EnableDayCapBySchedules',
      'MedicareConsent',
      'CallCredits',
      'EnableBulkBucketFunding',
      'Chatbot',
      'UnlimitedVacationPauseHours',
      'EnableSelfServiceReactivation',
    ]);

    commit('setFlags', flags);
    commit('setIsInit', true);

    return flags;
  },

  async checkFlagForClient(_, { flagName, carrier, clientType, clientId }) {
    return await getFeatureFlag(flagName, carrier, clientType, clientId);
  },

  reset({ commit }) {
    commit('setFlags', {});
    commit('setIsInit', false);
  },
};

export const mutations = {
  setFlags(state, value) {
    state.flags = value;
  },
  setIsInit(state, value) {
    state.isInit = value;
  },
  setFlag(state, { flag, value }) {
    state.flags[flag] = value;
  },
};
